import type { FunctionComponent } from 'react';
import { ContentBrick } from '../../../app-kit/components/ContentBrick/ContentBrick';
import { LinkCollection } from '../../../components/LinkCollection/LinkCollection';
import { useStatePageQuery } from '../../graphql/useStatePageQuery';

export const StatePageSuburbsWithData: FunctionComponent = () => {
  const suburbs = useStatePageQuery()?.data?.statePageBySlug?.suburbs;
  if (!suburbs) return null;

  const {
    title,
    subtitle,
    items: { visible, hidden },
    showMoreButton,
  } = suburbs;

  return (
    <ContentBrick title={title} subtitle={subtitle}>
      <LinkCollection
        visible={visible}
        hidden={hidden}
        showMoreButtonText={showMoreButton?.title}
      />
    </ContentBrick>
  );
};
